import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  User,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.authorization}users/${COMMON_QUERY_PARAMS.USER_ID}`;

export interface GetUserInformationByIdQueryPayload {
  userId: string;
}

export const getUserInformationByIdRequest = ({
  userId,
}: GetUserInformationByIdQueryPayload): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.USER_ID, userId),
  config: { method: SUPPORTED_METHODS.GET },
});

const getUserInformationByIdQuery = async ({
  userId,
}: GetUserInformationByIdQueryPayload): Promise<
  BackResponse<User> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<User>>(
      getUserInformationByIdRequest({ userId }),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getUserInformationByIdQuery;
